import { Trans } from "@lingui/react/macro";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { DateRangeActions } from "../NextBase/DateRangeActions";
import { useCalendarStore } from "@/pages/Dashboard/Calendar/store/useCalendarStore";
import classes from "./ExportPdfModal.module.css";
import { useExportPdfModal } from "./useExportPdfModal";
import {
  Accordion,
  AccordionItem,
  Button,
  Checkbox,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "@heroui/react";
import { ArrowDownToLine } from "lucide-react";

export const ExportPdfModal = () => {
  const { calendarMode } = useCalendarStore((state) => state);

  const {
    ref,
    userIds,
    serviceIds,
    setDateRange,
    usersServicesData,
    handleExport,
    modalOpened,
    setModalOpened,
    selectAllServices,
    selectAllUsers,
    toggleServiceSelection,
    toggleResourceSelection,
    toggleUserSelection,
    contentToPrint,
    biggerRowSize,
    setBiggerRowSize,
    selectAllResources,
    resourceIds,
  } = useExportPdfModal();

  if (!usersServicesData) return null;

  return (
    <>
      <Button
        onPress={() => setModalOpened(true)}
        startContent={<ArrowDownToLine size={16} />}
        variant="flat"
        className="shrink-0"
      >
        <p>
          <Trans>Prenos v PDF obliki</Trans>
        </p>
      </Button>

      <div id="print-content" ref={ref} style={{ display: "none" }}>
        {contentToPrint}
      </div>

      <Drawer isOpen={modalOpened} onClose={() => setModalOpened(false)}>
        <DrawerContent>
          <DrawerHeader>
            <Trans>Nastavitve prenosa</Trans>
          </DrawerHeader>
          <DrawerBody>
            <div className="flex flex-col gap-4">
              <DateRangeActions
                handleChangeDateRange={(start, end) => {
                  setDateRange([start, end]);
                }}
                defaultSelectedOption="1d"
                future={true}
              ></DateRangeActions>

              <Checkbox
                isSelected={biggerRowSize}
                onValueChange={(value) => setBiggerRowSize(value)}
              >
                <Trans>Dodaj prostor za zapiske pod termini</Trans>
              </Checkbox>

              <Accordion variant="bordered">
                {calendarMode === "users" ? (
                  <AccordionItem title={<Trans>Zaposleni</Trans>} key="users">
                    <button
                      onClick={selectAllUsers}
                      style={{
                        display: "flex",
                        gap: "0.5rem",
                        alignItems: "center",

                        borderRadius: 7,

                        marginBottom: 12,

                        padding: "0.5rem 1rem",
                        width: "100%",

                        background: "#74B58710",
                        color: `${
                          userIds.length === usersServicesData.users.length
                            ? "#74B587"
                            : "#949494"
                        }`,
                      }}
                    >
                      <RiCheckboxCircleLine size={20}></RiCheckboxCircleLine>
                      <Trans>Izberi vse</Trans>{" "}
                    </button>
                    {usersServicesData.users.map((user) => (
                      <button
                        key={user.userId}
                        onClick={() => {
                          toggleUserSelection(user.userId);
                        }}
                        className={classes.item}
                        style={{
                          display: "flex",
                          alignItems: "center",

                          borderRadius: 7,
                          padding: "0.5rem 1rem",

                          width: "100%",

                          border: `1px solid ${
                            userIds.includes(user.userId)
                              ? "#74B587"
                              : "rgb(236, 237, 239)"
                          }`,
                          fontSize: "0.92rem",

                          marginBottom: 12,
                        }}
                      >
                        <div
                          className={` ${
                            userIds.includes(user.userId) ? classes.active : ""
                          } ${classes.color}`}
                        ></div>
                        {`${user.name} ${user.lastName}`}
                      </button>
                    ))}
                  </AccordionItem>
                ) : (
                  <></>
                )}

                {calendarMode === "resources" ? (
                  <AccordionItem
                    title={<Trans>Sredstva</Trans>}
                    key="resources"
                  >
                    <button
                      className={"select-all"}
                      onClick={selectAllResources}
                      style={{
                        display: "flex",
                        gap: "0.5rem",
                        alignItems: "center",

                        borderRadius: 7,
                        marginBottom: 12,

                        padding: "0.5rem 1rem",
                        width: "100%",

                        background: "#74B58710",
                        color: `${
                          resourceIds.length ===
                          usersServicesData.resources.length
                            ? "#74B587"
                            : "#949494"
                        }`,
                      }}
                    >
                      <RiCheckboxCircleLine size={20}></RiCheckboxCircleLine>
                      <Trans>Izberi vse</Trans>{" "}
                    </button>
                    {usersServicesData.resources.map((resource) => (
                      <button
                        className={classes.item}
                        key={resource.id}
                        onClick={() => {
                          toggleResourceSelection(resource.id);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",

                          borderRadius: 7,
                          padding: "0.5rem 1rem",

                          width: "100%",

                          border: `1px solid ${
                            resourceIds.includes(resource.id)
                              ? "#74B587"
                              : "rgb(236, 237, 239)"
                          }`,
                          fontSize: "0.92rem",

                          marginBottom: 12,
                        }}
                      >
                        <div
                          className={` ${
                            resourceIds.includes(resource.id)
                              ? classes.active
                              : ""
                          } ${classes.color}`}
                        ></div>
                        {resource.label}
                      </button>
                    ))}
                  </AccordionItem>
                ) : (
                  <></>
                )}

                <AccordionItem title={<Trans>Storitve</Trans>} key="services">
                  <button
                    className={"select-all"}
                    onClick={selectAllServices}
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "center",

                      borderRadius: 7,
                      marginBottom: 12,

                      padding: "0.5rem 1rem",
                      width: "100%",

                      background: "#74B58710",
                      color: `${
                        serviceIds.length === usersServicesData.services.length
                          ? "#74B587"
                          : "#949494"
                      }`,
                    }}
                  >
                    <RiCheckboxCircleLine size={20}></RiCheckboxCircleLine>
                    <Trans>Izberi vse</Trans>{" "}
                  </button>
                  {usersServicesData.services.map((service) => (
                    <button
                      className={classes.item}
                      key={service.serviceId}
                      onClick={() => {
                        toggleServiceSelection(service.serviceId);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",

                        borderRadius: 7,
                        padding: "0.5rem 1rem",

                        width: "100%",

                        border: `1px solid ${
                          serviceIds.includes(service.serviceId)
                            ? "#74B587"
                            : "rgb(236, 237, 239)"
                        }`,
                        fontSize: "0.92rem",

                        marginBottom: 12,
                      }}
                    >
                      <div
                        className={` ${
                          serviceIds.includes(service.serviceId)
                            ? classes.active
                            : ""
                        } ${classes.color}`}
                      ></div>
                      {service.name}
                    </button>
                  ))}
                </AccordionItem>
              </Accordion>
            </div>
          </DrawerBody>
          <DrawerFooter>
            <Button onPress={() => setModalOpened(false)} variant="flat">
              <Trans>Prekliči</Trans>
            </Button>
            <Button onPress={handleExport} color="primary">
              <Trans>Natisni</Trans>
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
